import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, TextField, DialogActions, Button, CircularProgress } from '@material-ui/core';
import useAsyncFn from 'react-use/lib/useAsyncFn';
import { pagerDutyApiRef } from '../../api/client.esm.js';
import { Alert } from '@material-ui/lab';
import { useApi, alertApiRef, identityApiRef } from '@backstage/core-plugin-api';
import { parseEntityRef, DEFAULT_NAMESPACE } from '@backstage/catalog-model';

const TriggerDialog = ({
  showDialog,
  handleDialog,
  onIncidentCreated,
  serviceName,
  integrationKey
}) => {
  const alertApi = useApi(alertApiRef);
  const identityApi = useApi(identityApiRef);
  const api = useApi(pagerDutyApiRef);
  const [description, setDescription] = useState("");
  const [{ value, loading, error }, handleTriggerAlarm] = useAsyncFn(
    async (descriptions) => {
      const { userEntityRef } = await identityApi.getBackstageIdentity();
      const { name: userName } = parseEntityRef(userEntityRef, {
        defaultKind: "User",
        defaultNamespace: DEFAULT_NAMESPACE
      });
      return await api.triggerAlarm({
        integrationKey,
        source: window.location.toString(),
        description: descriptions,
        userName
      });
    }
  );
  const descriptionChanged = (event) => {
    setDescription(event.target.value);
  };
  useEffect(() => {
    if (value) {
      (async () => {
        alertApi.post({
          message: `Alarm successfully triggered`
        });
        setDescription("");
        handleDialog();
        await new Promise((resolve) => setTimeout(resolve, 1e3));
        onIncidentCreated == null ? void 0 : onIncidentCreated();
      })();
    }
  }, [value, alertApi, handleDialog, onIncidentCreated]);
  if (error) {
    alertApi.post({
      message: `Failed to trigger alarm. ${error.message}`,
      severity: "error"
    });
  }
  return /* @__PURE__ */ React.createElement(Dialog, { maxWidth: "md", open: showDialog, onClose: handleDialog, fullWidth: true }, /* @__PURE__ */ React.createElement(DialogTitle, null, "This action will trigger an incident for ", /* @__PURE__ */ React.createElement("strong", null, '"', serviceName, '"'), "."), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(Alert, { severity: "info" }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1", align: "justify" }, `If the issue you are seeing does not need urgent attention, please get in touch with the responsible team using their preferred communications channel. You can find information about the owner of this entity in the "About" card. If the issue is urgent, please don't hesitate to trigger the alert.`)), /* @__PURE__ */ React.createElement(
    Typography,
    {
      variant: "body1",
      style: { marginTop: "1em" },
      gutterBottom: true,
      align: "justify"
    },
    "Please describe the problem you want to report. Be as descriptive as possible. Your signed in user and a reference to the current page will automatically be amended to the alarm so that the receiver can reach out to you if necessary."
  ), /* @__PURE__ */ React.createElement(
    TextField,
    {
      inputProps: { "data-testid": "trigger-input" },
      id: "description",
      multiline: true,
      fullWidth: true,
      minRows: 4,
      margin: "normal",
      label: "Problem description",
      variant: "outlined",
      onChange: descriptionChanged
    }
  )), /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      "data-testid": "trigger-button",
      id: "trigger",
      color: "secondary",
      disabled: !description || loading,
      variant: "contained",
      onClick: () => handleTriggerAlarm(description),
      endIcon: loading && /* @__PURE__ */ React.createElement(CircularProgress, { size: 16 })
    },
    "Trigger Incident"
  ), /* @__PURE__ */ React.createElement(Button, { id: "close", color: "primary", onClick: handleDialog }, "Close")));
};

export { TriggerDialog };
//# sourceMappingURL=TriggerDialog.esm.js.map
